import React from "react";
import ResultSummary from "./result";
import ChipSelect from "../../../components/chipSelect";
import FieldLabel from "../../../components/label";
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { mapping, options } from "../../../defaultValues/product";
import {
  convertToAge,
  getStorageItem,
  validateInputLength,
} from "../../../helpers/utils";
import {
  maximumPolicyTenure,
  rebuildCorpusOptions,
  rebuildLanguageOptions,
  rebuildPremiumOptions,
  rebuildPolicyTermOptions,
} from "../../../helpers/product";
import { getMinDobDate, getMaxDobDate } from "../../../helpers/buyflow";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function ProductSavings({
  classes: { cardContainer, formGroup, gridChip, gridLabel },
  backdrop = false,
  errorMessage,
  handleChange,
  handleChangeCheckbox,
  handleChangeChipSelect,
  isInputValid,
  form,
  maxADBSumAssured,
  minAnnualIcome,
  quotation,
  selectedProduct,
}) {
  return (
    <>
      <Box m={0} mb={1} className={cardContainer}>
        <Box className={formGroup} pb={0} pt={0}>
          <FieldLabel label={"About You"} variant="subtitle1" />
        </Box>
        <Box className={formGroup} pb={0}>
          <Grid container spacing={1}>
            <Grid item xs={6} className={gridLabel}>
              <Box mb={0}>
                <FieldLabel label={"Date of Birth"} />
              </Box>
              <Box>
                <FieldLabel
                  label={`(${mapping.minAgeLimit[form.type]}-${Number(
                    mapping.maxAgeLimit[form.type] - 1
                  )} Years)`}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <TextField
                type="date"
                id="standard-basic"
                variant="outlined"
                value={form.dob}
                name="dob"
                onInput={validateInputLength}
                onChange={handleChange}
                autoComplete="off"
                // helperText={errorMessage.dob}
                style={{ width: "100%" }}
                fullWidth
                InputProps={{
                  inputProps: {
                    min: getMinDobDate(mapping.maxAgeLimit[form.type]),
                    max: getMaxDobDate(mapping.minAgeLimit[form.type]),
                  },
                }}
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    height: 48, // set desired height
                  },
                  "& input": {
                    paddingY: 1.2, // control padding inside
                  },
                }}
              />
            </Grid>
          </Grid>
        </Box>
        {errorMessage.dob && (
          <Box className={formGroup} pb={0} textAlign="left">
            <Box className="error-message">
              <Typography variant="caption">{errorMessage.dob}</Typography>
            </Box>
          </Box>
        )}
        {selectedProduct?.productConfig?.education?.length > 0 &&
          selectedProduct?.productConfig?.default_education && (
            <Box className={formGroup} pb={0}>
              <Grid container spacing={1}>
                <Grid item xs={6} className={gridLabel}>
                  <FieldLabel label={"Education"} />
                </Grid>
                <Grid item xs={6} className={gridChip}>
                  <FormControl variant="outlined" fullWidth>
                    <Box
                      justifyContent="flex-start"
                      display="flex"
                      textAlign="left"
                      fullWidth
                    >
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={form?.education}
                        onChange={handleChange}
                        name="education"
                        fullWidth
                        sx={{
                          height: 48, // set height
                          "& .MuiSelect-select": {
                            paddingY: 1.2, // control padding inside
                          },
                        }}
                      >
                        {selectedProduct?.productConfig?.education.map(
                          (option) => {
                            return (
                              <MenuItem
                                key={`education-${option.value}`}
                                value={option.value}
                              >
                                <Typography variant="caption">
                                  {option.title}
                                </Typography>
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </Box>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          )}
        <Box className={formGroup} mt={1} pt={0} pb={0}>
          <Grid container spacing={1}>
            <Grid item xs={3} className={gridLabel}>
              <FieldLabel label={"Gender"} />
            </Grid>
            <Grid item xs={9} className={gridChip}>
              <ChipSelect
                compact={false}
                fontWeight={"regular"}
                fieldname={"gender"}
                handleChange={handleChangeChipSelect}
                options={options.gender}
                selectedItem={form.gender}
              />
            </Grid>
          </Grid>
        </Box>
        {selectedProduct?.productConfig?.occupation.length > 0 && (
          <Box className={formGroup} mt={1} pt={0} pb={0}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={
                  selectedProduct?.productConfig?.occupation?.length > 2
                    ? 12
                    : 3
                }
                className={gridLabel}
              >
                <FieldLabel label={"Occupation"} />
              </Grid>
              <Grid
                item
                xs={
                  selectedProduct?.productConfig?.occupation?.length > 2
                    ? 12
                    : 9
                }
                className={gridChip}
              >
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"occupation"}
                  handleChange={handleChangeChipSelect}
                  options={selectedProduct?.productConfig?.occupation ?? []}
                  selectedItem={form.occupation}
                  padding={0.5}
                />
              </Grid>
            </Grid>
          </Box>
        )}

        {/* selectedProduct?.productConfig?.annual_income && */}
        {form.dob && (
          <Box className={formGroup} pb={0}>
            <Grid container spacing={1}>
              <Grid item xs={6} className={gridLabel}>
                <Box mb={0}>
                  <FieldLabel label={"Annual Income"} />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  type="text"
                  id="standard-basic"
                  variant="outlined"
                  value={form.annualIncome}
                  name="annualIncome"
                  onInput={validateInputLength}
                  onChange={handleChange}
                  autoComplete="off"
                  style={{ width: "100%" }}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 48, // set desired height
                    },
                    "& input": {
                      paddingY: 1.2, // control padding inside
                    },
                  }}
                  {...((!form.dob || form.isFormSubmitted || backdrop) && {
                    disabled: true,
                  })}
                />
              </Grid>
            </Grid>
          </Box>
        )}
        {errorMessage.annualIncome && !isInputValid && (
          <Box className={formGroup} pb={0} textAlign="left">
            <Box className="error-message">
              <Typography variant="caption">
                {errorMessage.annualIncome}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>

      <Box m={0} mt={2} mb={0.5} className={cardContainer}>
        <Box className={formGroup} pb={0} pt={0}>
          <FieldLabel label={"About Your Plan"} variant="subtitle1" />
        </Box>

        <Box className={formGroup}>
          <Grid container spacing={1}>
            <Grid item xs={7} className={gridLabel}>
              <FieldLabel
                label={"Preferred language of product communication"}
              />
            </Grid>
            <Grid item xs={5} className={gridChip}>
              <FormControl variant="outlined" fullWidth>
                <Box
                  justifyContent="flex-start"
                  display="flex"
                  textAlign="left"
                  fullWidth
                >
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={form?.language}
                    onChange={handleChange}
                    name="language"
                    fullWidth
                    sx={{
                      height: 48, // set height
                      "& .MuiSelect-select": {
                        paddingY: 1.2, // control padding inside
                      },
                    }}
                  >
                    {rebuildLanguageOptions().map((option) => {
                      return (
                        <MenuItem
                          key={`education-${option.value}`}
                          value={option.value}
                        >
                          <Typography variant="caption">
                            {option.title}
                          </Typography>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Box>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        {selectedProduct?.paymentFrequencyList?.length > 1 && (
          <Box className={formGroup} pt={0}>
            <Grid container spacing={1}>
              <Grid item xs={7} className={gridLabel}>
                <FieldLabel label={"Payment Frequency"} />
              </Grid>
              <Grid item xs={5} className={gridChip}>
                <FormControl variant="outlined" fullWidth>
                  <Box
                    justifyContent="flex-start"
                    display="flex"
                    textAlign="left"
                    fullWidth
                  >
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={form?.paymentFrequency}
                      onChange={handleChange}
                      name="paymentFrequency"
                      fullWidth
                      sx={{
                        height: 48, // set height
                        "& .MuiSelect-select": {
                          paddingY: 1.2, // control padding inside
                        },
                      }}
                    >
                      {selectedProduct.paymentFrequencyList.map((option) => {
                        return (
                          <MenuItem
                            key={`education-${option.value}`}
                            value={option.value}
                          >
                            <Typography variant="caption">
                              {option.title}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Box>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        )}

        {selectedProduct?.multiplierList?.length > 1 && (
          <Box className={formGroup} pt={0} pb={0}>
            <Grid container spacing={1}>
              <Grid item xs={3} className={gridLabel}>
                <FieldLabel label={"Multiplier"} />
              </Grid>
              <Grid item xs={9} className={gridChip}>
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"multiplier"}
                  handleChange={handleChangeChipSelect}
                  options={selectedProduct.multiplierList}
                  selectedItem={form.multiplier}
                />
              </Grid>
            </Grid>
          </Box>
        )}

        {selectedProduct?.pptList?.length > 1 && (
          <Box className={formGroup} pt={0} pb={0}>
            <Grid container spacing={1}>
              <Grid item xs={3} className={gridLabel}>
                <FieldLabel label={"PPT"} />
              </Grid>
              <Grid item xs={9} className={gridChip}>
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"ppt"}
                  handleChange={handleChangeChipSelect}
                  options={selectedProduct.pptList}
                  selectedItem={form.ppt}
                />
              </Grid>
            </Grid>
          </Box>
        )}

        {form?.policyTermOptions?.length > 0 && form.age && (
          <>
            <Box className={formGroup} textAlign={"left"} pt={0} pb={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} className={gridLabel}>
                  <FieldLabel label={`Policy Term (Years)`} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={gridChip}
                  sx={{ justifyContent: "flex-start" }}
                >
                  <Box display="flex">
                    <ChipSelect
                      compact={false}
                      fontWeight={"regular"}
                      fieldname={"ppt"}
                      handleChange={handleChangeChipSelect}
                      options={
                        rebuildPolicyTermOptions(
                          selectedProduct?.productConfig ?? null,
                          convertToAge(form.dob)
                        ) ?? []
                      }
                      selectedItem={form?.ppt}
                      padding={0}
                      paddingRight={0.25}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            {selectedProduct?.productConfig?.policy_term_textbox && (
              <>
                <Box
                  className={formGroup}
                  textAlign={"center"}
                  pt={0}
                  pb={0}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <FieldLabel label={"OR"} />
                </Box>

                <Box className={formGroup} textAlign={"left"} pt={0} pb={1}>
                  <FieldLabel
                    label={` Other Policy Term (${
                      rebuildPolicyTermOptions(
                        selectedProduct?.productConfig ?? null,
                        convertToAge(form.dob)
                      )[0]?.value
                    } -
                    ${maximumPolicyTenure(
                      form.dob,
                      selectedProduct?.productConfig?.max_coverage_age
                    )} years)`}
                  />
                  <Box display="flex" sx={{ width: "100%" }}>
                    <TextField
                      type="number"
                      id="standard-basic"
                      variant="outlined"
                      value={form.ppt}
                      name="ppt"
                      // onInput={validateInputLength}
                      onChange={handleChange}
                      autoComplete="off"
                      style={{ width: "100%" }}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 48, // set desired height
                        },
                        "& input": {
                          paddingY: 1.2, // control padding inside
                        },
                      }}
                    />
                  </Box>
                </Box>

                {errorMessage.ppt && (
                  <Box className={formGroup} pt={0} pb={0} textAlign="left">
                    <Box className="error-message">
                      <Typography variant="caption">
                        {`Policy Term must be between 10 and ${maximumPolicyTenure(
                          form.dob,
                          selectedProduct?.productConfig?.max_coverage_age
                        )} years`}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </>
            )}
          </>
        )}

        {form.premiumOptions.length > 0 && (
          <>
            <Box className={formGroup} textAlign={"left"} pt={0} pb={0}>
              <FieldLabel
                label={`The ${form.paymentFrequency.toLowerCase()} premium (in ₹) you invest for the next ${
                  form.ppt
                } years`}
              />
              <Box display="flex">
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"premium"}
                  handleChange={handleChangeChipSelect}
                  options={rebuildPremiumOptions(form)}
                  selectedItem={form?.premium}
                  padding={0}
                  paddingRight={0.25}
                />
              </Box>
            </Box>
          </>
        )}

        {form.corpusOptions.length > 0 && (
          <>
            <Box className={formGroup} textAlign={"left"} pt={0} pb={1}>
              <FieldLabel label={"Life Coverage (Lakhs)"} />
              <Box display="flex">
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"corpus"}
                  handleChange={handleChangeChipSelect}
                  options={rebuildCorpusOptions(form)}
                  selectedItem={form?.corpus}
                  padding={0}
                  paddingRight={0.25}
                />
              </Box>
            </Box>

            {selectedProduct?.productConfig?.life_coverege_textbox && (
              <>
                <Box
                  className={formGroup}
                  textAlign={"center"}
                  pt={0}
                  pb={0}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <FieldLabel label={"OR"} />
                </Box>

                <Box className={formGroup} textAlign={"left"} pt={0} pb={0}>
                  <FieldLabel label={` Other Amount (in multiples of 50K)`} />
                  <Box display="flex" sx={{ width: "100%" }}>
                    <TextField
                      type="number"
                      id="standard-basic"
                      variant="outlined"
                      value={form.corpus}
                      name="corpus"
                      // onInput={validateInputLength}
                      onChange={handleChange}
                      autoComplete="off"
                      style={{ width: "100%" }}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 48, // set desired height
                        },
                        "& input": {
                          paddingY: 1.2, // control padding inside
                        },
                      }}
                    />
                  </Box>
                </Box>

                {errorMessage.corpus && (
                  <Box className={formGroup} pb={0} textAlign="left">
                    <Box className="error-message">
                      <Typography variant="caption">
                        {`Amount must be between 5 to ${
                          mapping.corpus[
                            rebuildCorpusOptions(form)[
                              rebuildCorpusOptions(form)?.length - 1
                            ]?.value
                          ]?.label
                        }`}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </>
            )}
          </>
        )}

        {/* Start Rider Section */}
        {selectedProduct?.productConfig?.riders?.length > 0 && (
          <>
            <Box className={formGroup} pb={0} pt={1}>
              <FieldLabel label={"Additional Benefits"} variant="subtitle1" />
            </Box>

            {selectedProduct?.productConfig?.riders?.map((rider) => (
              <Box className={formGroup} pb={0} pt={0} key={rider.slug}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.riders[rider.slug] || false}
                      onChange={(e) => handleChangeCheckbox(e, rider.slug)}
                      name={rider.slug}
                      color="primary"
                      disabled={backdrop}
                    />
                  }
                  label={
                    <Box
                      display={"flex"}
                      justifyContent={"flex-start"}
                      textAlign={"left"}
                    >
                      <FieldLabel
                        variant={"small"}
                        label={`${
                          form?.corpus > maxADBSumAssured
                            ? mapping?.corpus[maxADBSumAssured]?.label
                            : mapping?.corpus[form?.corpus]?.label
                        } Payout on ${rider.name}`}
                        mb={0}
                      />
                    </Box>
                  }
                />
                {rider.recommended && (
                  <Box mt={-1.5} ml={4}>
                    <Chip
                      label="Recommended"
                      color="success"
                      size="small"
                      sx={{
                        fontSize: "12px",
                        padding: 1,
                        // borderRadius: 1,
                        cursor: "default", // Ensures it's non-clickable visually
                        pointerEvents: "none", // Prevents any interaction
                        opacity: 0.6, // Optional: visually de-emphasize if desired
                      }}
                      tabIndex={-1} // Prevents keyboard focus
                    />
                  </Box>
                )}
              </Box>
            ))}
          </>
        )}
      </Box>
      {/* End Rider Section */}

      {quotation.maturityTerminalBonus1 && (
        <ResultSummary
          form={form}
          selectedProduct={selectedProduct}
          quotation={quotation}
        />
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProductSavings);
